type EventLevel = {
  levelid: string;
  price: number | string | null;
};

type EventLevelDiscount = {
  levelid: string;
  discount: number | string;
};

export type EventPromotion =
  | {
      offer_discount: number | string;
      levels_discount?: EventLevelDiscount[] | null;
    }
  | {
      offer_discount?: number | string | null;
      levels_discount: EventLevelDiscount[];
    };

export function getDiscountedEventLevelPrice(
  level: EventLevel,
  promotion?: EventPromotion,
  options: { useOfferDiscountFallback?: boolean } = {}
) {
  const price = Number(level.price) || 0;
  const levelDiscount = promotion?.levels_discount
    ? findEventLevelDiscount(promotion.levels_discount, level.levelid)
    : undefined;
  const discount =
    levelDiscount?.discount ??
    (options.useOfferDiscountFallback ? promotion?.offer_discount : undefined);

  if (discount === null || typeof discount === "undefined") {
    return price;
  }

  return Math.round(calculateDiscountedPrice(price, discount) * 100) / 100;
}

export function findEventLevelDiscount(
  levelsDiscount: EventLevelDiscount[],
  levelid: string
) {
  return levelsDiscount.find((discount) => discount.levelid === levelid);
}

function calculateDiscountedPrice(
  originalPrice: number | string | null,
  discountPercent: number | string
) {
  const price = Number(originalPrice) || 0;
  const discount = Number(discountPercent) || 0;
  return price - price * (discount / 100);
}
